import React, { createContext, useState, useContext, useEffect } from 'react';
import { SecureStorage } from '../Utilities/StorageEncryption';

const DomainContext = createContext();

export const DomainProvider = ({ children }) => {
  const [domain, setDomainState] = useState(() => SecureStorage.getItem('domain') || null);

  // Sync from SecureStorage on mount (e.g. after page refresh)
  useEffect(() => {
    const stored = SecureStorage.getItem('domain');
    if (stored) {
      setDomainState(stored);
    }
  }, []);

  const setDomain = (value) => {
    const domainStr = value != null ? String(value) : null;
    setDomainState(domainStr);
    if (domainStr) {
      SecureStorage.setItem('domain', domainStr);
    } else {
      SecureStorage.removeItem('domain');
    }
  };

  const clearDomain = () => {
    setDomainState(null);
    SecureStorage.removeItem('domain');
  };

  // Fallback to SecureStorage when context domain is null (e.g. initial sync)
  const effectiveDomain = domain ?? SecureStorage.getItem('domain');

  const value = {
    domain: effectiveDomain,
    setDomain,
    clearDomain,
    hasDomain: Boolean(effectiveDomain),
  };

  return <DomainContext.Provider value={value}>{children}</DomainContext.Provider>;
};

export const useDomain = () => {
  const context = useContext(DomainContext);
  if (!context) {
    return {
      domain: SecureStorage.getItem('domain'),
      setDomain: (v) => {
        if (v != null) SecureStorage.setItem('domain', String(v));
      },
      clearDomain: () => SecureStorage.removeItem('domain'),
      hasDomain: Boolean(SecureStorage.getItem('domain')),
    };
  }
  return context;
};
